module.exports = __webpack_public_path__ + "img/header-logo.2ac7143b.png";